__turbopack_context__.v({
  "actions": "cookie-consent-module-scss-module__vyV7xW__actions",
  "banner": "cookie-consent-module-scss-module__vyV7xW__banner",
  "btnOutline": "cookie-consent-module-scss-module__vyV7xW__btnOutline",
  "btnPrimary": "cookie-consent-module-scss-module__vyV7xW__btnPrimary",
  "content": "cookie-consent-module-scss-module__vyV7xW__content",
  "desktop": "cookie-consent-module-scss-module__vyV7xW__desktop",
  "link": "cookie-consent-module-scss-module__vyV7xW__link",
  "mobile": "cookie-consent-module-scss-module__vyV7xW__mobile",
  "row": "cookie-consent-module-scss-module__vyV7xW__row",
  "text": "cookie-consent-module-scss-module__vyV7xW__text",
  "title": "cookie-consent-module-scss-module__vyV7xW__title",
});
